  document.addEventListener('DOMContentLoaded', function() {
    // Seleccionamos el contenedor donde está tu texto
    var container = document.querySelector('.m-richtext__description-seo');
    
    if (container) {
      var children = Array.from(container.children);
      var wrapper = document.createDocumentFragment();

      // Recorremos los elementos
      for (var i = 0; i < children.length; i++) {
        var current = children[i];

        // Si encontramos un H2, creamos una columna
        if (current.tagName === 'H2') {
          var columnDiv = document.createElement('div');
          columnDiv.className = 'columna-texto'; // Clase para estilizar
          columnDiv.appendChild(current); // Metemos el H2

          // Verificamos si el siguiente elemento es un P
          if (children[i + 1] && children[i + 1].tagName === 'P') {
            columnDiv.appendChild(children[i + 1]); // Metemos el P dentro de la misma columna
            i++; // Saltamos el índice del P porque ya lo movimos
          }
          
          wrapper.appendChild(columnDiv);
        } 
        // Si hay un P suelto (sin H2 antes), lo metemos en una columna aparte para no perderlo
        else if (current.tagName === 'P') {
           var columnDiv = document.createElement('div');
           columnDiv.className = 'columna-texto';
           columnDiv.appendChild(current);
           wrapper.appendChild(columnDiv);
        }
      }

      // Limpiamos el contenedor original y pegamos las nuevas columnas
      container.innerHTML = '';
      container.appendChild(wrapper);
    }
  });
